export default function MetricCard({ label, value, subValue, accent, icon: Icon, testId }) {
  const accentCls =
    accent === "danger" ? "text-accent" :
    accent === "success" ? "text-success" : "text-foreground";

  return (
    <div
      data-testid={testId}
      className="relative border border-border bg-card p-6 lg:p-7 rounded-md hover:-translate-y-0.5 transition-transform"
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-mono">{label}</div>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" weight="duotone" />}
      </div>
      <div className={`font-mono tabular-nums text-3xl lg:text-4xl font-semibold mt-3 ${accentCls}`}>
        {value}
      </div>
      {subValue && <div className="text-xs text-muted-foreground mt-2">{subValue}</div>}
    </div>
  );
}
